export enum FiltersSectionComponentHidingButtonMode {
  ALL = 'all',
  SECOND_ROW = 'second-row',
}

export enum FiltersSectionTheme {
  LIST = 'theme-list',
  MODAL = 'theme-modal',
}
